import { buildGrantUrl } from 'components/nylas/v3/grant/helpers';
import { scopesFor } from 'components/nylas/v3/grant/scopes';

import type { ProviderName } from 'components/nylas/v3/types';
import type { EmailFile, EmailFileReference, SendEmailConfig } from './types';

export function isFileReference(file: EmailFile): file is EmailFileReference {
  return !(file instanceof File);
}

export function getFileName(file: EmailFile): string {
  return isFileReference(file) ? file.filename : file.name;
}

export function getFileSize(file: EmailFile): number {
  return isFileReference(file) ? file.byteSize : file.size;
}

// Round-tripped through Nylas as the OAuth `state` so the callback can return the broker to this
// contact and reopen the compose modal. Parsed server-side against /\Acompose_email:(\d+)\z/.
export function composeReturnState(contactId: number): string {
  return `compose_email:${contactId}`;
}

export function buildReauthUrl(authPath: string, provider: ProviderName, contactId: number): URL {
  return buildGrantUrl(authPath, provider, scopesFor(provider, true), composeReturnState(contactId));
}

// True when the page was reached via the post-reauth redirect and the mailbox can now send.
export function shouldAutoOpenCompose(search: string, sendEmail?: SendEmailConfig): boolean {
  if (!sendEmail?.enabled || !sendEmail.canSend || !sendEmail.path) return false;

  return new URLSearchParams(search).get('compose_email') === '1';
}
